module.exports = __webpack_public_path__ + "features-page-changelog-d1fc5714ab474f2cc2fef82564d75765.jpg";